// fetch linked providers action
const LINKEDPROVIDERS_FETCH = 'Providers/LinkedFetching';
const LINKEDPROVIDERS_FETCH_SUCCESS = 'Providers/LinkedFetchSuccess';
const LINKEDPROVIDERS_FETCH_ERROR = 'Providers/LinkedFetchError';

export { LINKEDPROVIDERS_FETCH, LINKEDPROVIDERS_FETCH_SUCCESS, LINKEDPROVIDERS_FETCH_ERROR };
